import React from 'react'
import Typography from '@material-ui/core/Typography'
import { Grid, Button, Tooltip } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { getFetchLogsUrl } from '../../redux/actions/logs'
import { exportFile } from '../../shared/utils/export'
import { config, getToken } from '../../config'
import { useTranslation } from 'react-i18next'
import { logsStyles } from './LogsStyles'
import LogsFilter from './LogsFilter/LogsFilter'
import LogsTable from './LogsTable/LogsTable'

export default function Logs() {
    const classes = logsStyles()
    const { t } = useTranslation()
    const logsFilter = useSelector((state: any) => state.logs.filter)
    const allLogs = useSelector((state: any) => state.logs.items)

    const handleFilteredDataDownload = () => {
        const url = 'DiagnosticsAdmin/diagnostic/txt?' + getFetchLogsUrl(1, allLogs.value.count, logsFilter)
        exportFile(config.proxy, config.api, url, getToken())
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12} className={classes.headerWrapper}>
                    <Typography align="left" variant="h3">
                        {t('logs.title')}
                    </Typography>
                    <Tooltip title={t('logs.exportTooltip') as string}>
                        <span>
                            <Button
                                className={classes.exportHeaderButton}
                                variant="contained"
                                color="primary"
                                disabled={!allLogs?.value?.count}
                                onClick={handleFilteredDataDownload}
                            >
                                {t('logs.export')}
                            </Button>
                        </span>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    <LogsFilter />
                </Grid>
                <Grid item sm={12} className={classes.contentIndent}>
                    <LogsTable />
                </Grid>
            </Grid>
        </>
    )
}
